// create/post
export const CREATE_RISK_PROFILE_ENTITY_REQUEST = "CREATE_RISK_PROFILE_ENTITY_REQUEST";
export const CREATE_RISK_PROFILE_ENTITY_SUCCESS = "CREATE_RISK_PROFILE_ENTITY_SUCCESS";
export const CREATE_RISK_PROFILE_ENTITY_FAIL = "CREATE_RISK_PROFILE_ENTITY_FAIL";

// get
export const RISK_PROFILE_ENTITY_REQUEST = "RISK_PROFILE_ENTITY_REQUEST";
export const RISK_PROFILE_ENTITY_SUCCESS = "RISK_PROFILE_ENTITY_SUCCESS";
export const RISK_PROFILE_ENTITY_FAIL = "RISK_PROFILE_ENTITY_FAIL";

// find
export const FIND_RISK_PROFILE_ENTITY_REQUEST = "FIND_RISK_PROFILE_ENTITY_REQUEST";
export const FIND_RISK_PROFILE_ENTITY_SUCCESS = "FIND_RISK_PROFILE_ENTITY_SUCCESS";
export const FIND_RISK_PROFILE_ENTITY_FAIL = "FIND_RISK_PROFILE_ENTITY_FAIL";

// update/put
export const UPDATE_RISK_PROFILE_ENTITY_REQUEST = "UPDATE_RISK_PROFILE_ENTITY_REQUEST";
export const UPDATE_RISK_PROFILE_ENTITY_SUCCESS = "UPDATE_RISK_PROFILE_ENTITY_SUCCESS";
export const UPDATE_RISK_PROFILE_ENTITY_FAIL = "UPDATE_RISK_PROFILE_ENTITY_FAIL";

// update/put
export const DELETE_RISK_PROFILE_ENTITY_REQUEST = "DELETE_RISK_PROFILE_ENTITY_REQUEST";
export const DELETE_RISK_PROFILE_ENTITY_SUCCESS = "DELETE_RISK_PROFILE_ENTITY_SUCCESS";
export const DELETE_RISK_PROFILE_ENTITY_FAIL = "DELETE_RISK_PROFILE_ENTITY_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";